import { MAIN_QUESTS_GROUP, appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const champzQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow on Immutable Play",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-wishlist-added",
    ruleId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/champz/ChampzTrailer.mp4`,
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-trailer-watched",
    ruleId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-trailer",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow on X",
    caption: "Don't miss a tweet",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-twitter-followed",
    ruleId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-twitter",
    linkUrl: "https://x.com/ChampzErc",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/champzerc",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-discord-followed",
    ruleId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-discord",
  },
  /*
  {
    type: "link",
    key: "telegram-v2",
    icon: "Telegram",
    label: "Join Telegram channel",
    caption: "Join our massively growing community",
    linkUrl: "https://t.me/champzerc",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-champz-telegram-validation-completed",
    ruleId: "champz-telegram-validation",
  },
  */
];

const champzQuestsLvl2: Quest[] = [
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Read the lore",
    caption: "Learn about the Champz universe",
    linkUrl: "https://champz.world/lore",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-lore-read",
    ruleId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-lore",
    waitTimeInHrs: 24,
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-onboarding-completed",
    ruleId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-onboarding",
  },
];

/*
export const champzSocialEngagementQuests: Quest[] = [
  {
    type: "custom",
    key: "social-engagement",
    icon: "SupportChat",
    label: "Post a message and engage in the Telegram channel daily",
    caption: "Earn gems everyday",
    increase: 10,
    badgeIcon: "ImxRewards",
    recurring: true,
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-champz-telegram-social-engagement-completed",
    ruleId: "champz-telegram-social-engagement",
  },
];
*/

const champzQuestsRecurring: Quest[] = [
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X about Champz",
    caption: "Extra Gems daily for sharing on X",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-recurring-tweet-completed",
    ruleId: "f92365fb-4b6b-43f8-be7b-f28a9d3df2d1-recurring-tweet",
    startTime: new Date("2025-03-30T02:00:00Z"),
    tweetText: "@ChampzErc",
    recurring: true,
    tweetUsername: "@ChampzErc",
  },
];

export const champzQuests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      title: "Learn and connect",
      description: "Level 1 Supporter",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +35 <icon> Gems",
    totalGemsGranted: 35,
    hideOnCompletion: true,
    lockedUntilPrevious: false,
    quests: champzQuestsLvl1,
    // Temporarily hidden as we run D0 prize give away model
    // introModal: {
    //   title: "You're on your way to Level 1 supporter",
    //   description:
    //     "Thanks for following Champz. Keep showing your support and earn better perks while doing it.",
    //   foregroundImage:
    //     "https://images.prismic.io/imtbl-player-portal/Z5r0MpbqstJ9-BhI_attack_f2p_lumberjack1.png?auto=format,compress",
    // },
  },
  {
    key: "level-2",
    header: {
      image: "",
      title: "Dive deeper",
      description: "Level 2 Believer",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +15 <icon> Gems",
    totalGemsGranted: 15,
    hideOnCompletion: false,
    lockedUntilPrevious: false,
    quests: champzQuestsLvl2,
    introModal: {
      title: "Level 2, here you go",
      description:
        "People like you are making Champz a better and bigger game. Let's keep at it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z5r0MpbqstJ9-BhJ_cast_f2p_alchemist1.png?auto=format,compress",
    },
    exitModal: {
      title: "That's all folks",
      description:
        "Level 2 Believer achieved. Bigger and better quests are on the horizon!",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z5r0M5bqstJ9-BhK_idle_1311.png?auto=format,compress",
    },
  },
  // {
  //   key: "social-engagement",
  //   header: {
  //     image: "",
  //     description: "",
  //     title: "Social Engagement",
  //   },
  //   totalGemsGranted: 10,
  //   quests: champzSocialEngagementQuests,
  //   hideOnCompletion: false,
  //   lockedUntilPrevious: false,
  //   questGroup: MAIN_QUESTS_GROUP,
  // },
  {
    key: "recurring",
    progressIcon: "ImxRewards",
    progressTemplate: "Earn extra gems daily",
    hideOnCompletion: false,
    header: {
      image: "",
      description: "",
      title: "Earn Gems daily by posting to socials",
    },
    totalGemsGranted: 10,
    quests: champzQuestsRecurring,
    questGroup: MAIN_QUESTS_GROUP,
  },
];
